module.exports = __webpack_public_path__ + "media/correct.580ffd48.mp3";